import { useAppDispatch, useAppSelector } from '../../../../../lib/redux/hooks';
import { PlusOrange } from '../../../../../ui/icons/plusOrange';
import { TrashIcon } from '../../../../../ui/icons/trash';
import { MadfarmInput } from '../../../../../ui/molecules/input/newInput';
import { addTrainingDefaultExternalTeacher, addTrainingDefaultExternalTeacherFunction, addUpdateTrainingDefaultExternalTeacher, addUpdateTrainingDefaultExternalTeacherFunction, setTrainingExternalTeacher, setTrainingExternalTeacherByIndex, setTrainingExternalTeacherFunction, setTrainingExternalTeacherFunctionByIndex, setUpdateTrainingExternalTeacher, setUpdateTrainingExternalTeacherByIndex, setUpdateTrainingExternalTeacherFunction, setUpdateTrainingExternalTeacherFunctionByIndex } from '../../slice';

export function ExternalTeachersAdd() {
    const dispatch = useAppDispatch()
    const trainingState = useAppSelector(state => state.PMTraining)

    return (
        <div className="flex flex-col gap-4 pb-6 border-b border-neutral-200">
            <div className="flex items-center justify-between">
                <p className="text-md font-semibold uppercase tracking-widest text-brandPrimary-600">Docenti esterni</p>
                <button
                    className="text-[#FF941A] flex items-center gap-2 text-sm font-semibold"
                    onClick={() => {
                        dispatch(addTrainingDefaultExternalTeacher())
                        dispatch(addTrainingDefaultExternalTeacherFunction())
                    }}
                >
                    Aggiungi docente esterno <PlusOrange color="#FF941A" size={20} />
                </button>
            </div>

            {trainingState.trainingCreationRequest.externalTeacher.map((t, index) => (
                <div key={index} className="rounded-xl border border-neutral-200 bg-white p-4">
                    <div className="grid grid-cols-1 md:grid-cols-[1fr_1fr_auto] gap-4 items-end">
                        <MadfarmInput
                            label="Nome e cognome"
                            placeholder="Nome e cognome del docente esterno"
                            value={trainingState.trainingCreationRequest.externalTeacher[index]}
                            defaultValue={trainingState.trainingCreationRequest.externalTeacher[index]}
                            onChangeText={(text) => dispatch(setTrainingExternalTeacherByIndex({ data: text, index }))}
                        />
                        <MadfarmInput
                            label="Funzione"
                            placeholder="Funzione del docente esterno"
                            value={trainingState.trainingCreationRequest.externalTeacherFunction[index]}
                            defaultValue={trainingState.trainingCreationRequest.externalTeacherFunction[index]}
                            onChangeText={(text) => dispatch(setTrainingExternalTeacherFunctionByIndex({ data: text, index }))}
                            error={trainingState.trainingErrors.externalTeacherFunction}
                            supportingText={trainingState.trainingErrors.externalTeacherFunction ? 'Nessuna funzione specificata' : undefined}
                        />
                        <button
                            className="p-1 rounded hover:bg-neutral-100 transition-colors mb-1"
                            onClick={() => {
                                dispatch(setTrainingExternalTeacher(trainingState.trainingCreationRequest.externalTeacher.filter((_, idx) => idx !== index)))
                                dispatch(setTrainingExternalTeacherFunction(trainingState.trainingCreationRequest.externalTeacherFunction.filter((_, idx) => idx !== index)))
                            }}
                        >
                            <TrashIcon color="#8383AD" size={20} />
                        </button>
                    </div>
                </div>
            ))}
        </div>
    )
}

export function ExternalTeachersEdit() {
    const dispatch = useAppDispatch()
    const trainingState = useAppSelector(state => state.PMTraining)

    return (
        <div className="flex flex-col gap-4 pb-6 border-b border-neutral-200">
            <div className="flex items-center justify-between">
                <p className="text-md font-semibold uppercase tracking-widest text-brandPrimary-600">Docenti esterni</p>
                <button
                    className="text-[#FF941A] flex items-center gap-2 text-sm font-semibold"
                    onClick={() => {
                        dispatch(addUpdateTrainingDefaultExternalTeacher())
                        dispatch(addUpdateTrainingDefaultExternalTeacherFunction())
                    }}
                >
                    Aggiungi docente esterno <PlusOrange color="#FF941A" size={20} />
                </button>
            </div>

            {trainingState.trainingUpdateRequest.externalTeacher.map((t, index) => (
                <div key={index} className="rounded-xl border border-neutral-200 bg-white p-4">
                    <div className="grid grid-cols-1 md:grid-cols-[1fr_1fr_auto] gap-4 items-end">
                        <MadfarmInput
                            label="Nome e cognome"
                            placeholder="Nome e cognome del docente esterno"
                            value={trainingState.trainingUpdateRequest.externalTeacher[index]}
                            defaultValue={trainingState.trainingUpdateRequest.externalTeacher[index]}
                            onChangeText={(text) => dispatch(setUpdateTrainingExternalTeacherByIndex({ data: text, index }))}
                        />
                        <MadfarmInput
                            label="Funzione"
                            placeholder="Funzione del docente esterno"
                            value={trainingState.trainingUpdateRequest.externalTeacherFunction[index]}
                            defaultValue={trainingState.trainingUpdateRequest.externalTeacherFunction[index]}
                            onChangeText={(text) => dispatch(setUpdateTrainingExternalTeacherFunctionByIndex({ data: text, index }))}
                        />
                        <button
                            className="p-1 rounded hover:bg-neutral-100 transition-colors mb-1"
                            onClick={() => {
                                dispatch(setUpdateTrainingExternalTeacher(trainingState.trainingUpdateRequest.externalTeacher.filter((_, idx) => idx !== index)))
                                dispatch(setUpdateTrainingExternalTeacherFunction(trainingState.trainingUpdateRequest.externalTeacherFunction.filter((_, idx) => idx !== index)))
                            }}
                        >
                            <TrashIcon color="#8383AD" size={20} />
                        </button>
                    </div>
                </div>
            ))}
        </div>
    )
}